import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  billNo: "",
  party: null,
  staff: null,
  name: "",
  branch: null,
  date: dayjs().format(),
  note: "",
  orderNo: 0,
  id: null,
  total: 0,
  discPerc: 0,
  discPercAmt: 0,
  discAmt: 0,
  taxPerc: 0,
  taxAmt: 0,
  otherChg: 0,
  netTotal: 0,
  receiptAmt: 0,
  cashP: "",
  receiptType: "",
  bankName: "",
  totalQty: 0,
  bankdetails:{
BillNo: null,
Name: "",
Narration: "",
NetTotal: null,
RetNo: null,
SiNo:null,
btbSiNo:null
  },
  balance: 0,
  deliveryDate: dayjs().format(),
 
};

const billDataSlice = createSlice({
  name: "billMaster",
  initialState,
  reducers: {
    // Update multiple fields dynamically using Object.assign
    UPDATE_BILL_HEAD(state, action) {
      Object.assign(state, action.payload);
    },

    // Reset state to its initial values using Object.assign
    RESET_BILL_HEAD(state) {
      Object.assign(state, initialState);
    },
  },
});

export const { UPDATE_BILL_HEAD, RESET_BILL_HEAD } = billDataSlice.actions;

export default billDataSlice.reducer;
